import { StringKeyDictionary } from "../../commonInterfaces.js";
import { Helper } from "./helper.js";
import { NotificationHelper } from "./notificationHelper.js";

export class ExternalOpenerHelper {

    //public static generateUrl = (statisticId: string, mapping: StringKeyDictionary<string>, object: {}) => {
    //    
    //.join("&")
    //    return `${Config.baseUrl}Statistic/ShowNoIframe?statisticId=${statisticId}&${params}`
    //}

    public static mapToUrlParams = (mapping: StringKeyDictionary<string>, object: {}) => {
        const keys = Object.keys(mapping);
        const params = keys.map((key) => {
            const target = mapping[key];
            const item = object[key];
            return ExternalOpenerHelper.tryMapToURLParam(target, item)
        }).filter(f => !Helper.isNullOrEmpty(f));
        return params;
    }

    private static tryMapToURLParam = (target: string, item): string => {
        const type = typeof item;
        switch (type) {
            case "bigint":
            case "number":
                return `${target}=${item}`;
            case "string":
                if (Helper.isNullOrEmpty(item))
                    return "";
                if (ExternalOpenerHelper.isDateString(item)) {
                    return `${target}=${Helper.dates.getISODateString(item)}`;
                } else {
                    return `${target}=${item}`;
                }
            case "boolean":
                return `${target}=${parseInt(item)}`;
            case "object":
                return ExternalOpenerHelper.tryMapObject(target, item);
            default:
                return "";
        }
    }

    private static tryMapObject = (target: string, item) => {
        if (Array.isArray(item)) {
            try {
                const arr: any[] = item;
                const params = arr.map(x => ExternalOpenerHelper.tryMapToURLParam(target, x));
                return params.join("&");
            } catch (e) {
                NotificationHelper.showErrorMessage("Un unexpected Error has occured");
                console.error(e);
                return "";
            }
        } else if (item instanceof Date) {
            const date = new Date(item);
            return `${target}=${Helper.dates.getISODateString(date)}`;
        } else {
            return "";
        }
    }

    private static isDateString = (value) => {
        const regex = new RegExp("^\\d{4}-[0|1]\\d-[0-3]\\dT[0-2]\\d:[0-5]\\d:[0-5]\\d(\.\\d{3}){0,1}Z{0,1}$");
        return regex.test(value);
    }
}

//